import axios from "axios";
import { getCanonicalPolishCity } from "../data/polishCities";

const FILTER_KEYS = ["online", "country", "city", "gender", "minAge", "maxAge"];

export function buildUsersQueryParams(filters = {}, page = 0, size = 30) {
  const params = new URLSearchParams();

  FILTER_KEYS.forEach((key) => {
    const value = filters[key];
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      const normalizedValue = key === "city" ? getCanonicalPolishCity(value) : String(value).trim();
      params.set(key, normalizedValue);
    }
  });

  params.set("page", String(page));
  params.set("size", String(size));
  return params;
}

export function fetchUsers({ token, filters, page, size }) {
  return axios.get(`/api/users?${buildUsersQueryParams(filters, page, size).toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}
